export default $form => {
  const formDtfSizes = {};

  const widthInput = $form.find(".js-dtf-width-input");
  const heightInput = $form.find(".js-dtf-height-input");

  if (widthInput.length && heightInput.length) {
    const width = widthInput.val();
    const height = heightInput.val();

    formDtfSizes.width = width;
    formDtfSizes.height = height;
    formDtfSizes.area = Math.round(width * height * 100) / 100;
  }

  return formDtfSizes;
};
